export default "\nuniform vec3 uColor;\nvarying vec3 vNormal;\n\nvoid main()\n{\n    gl_FragColor = vec4(uColor, 1.);\n}\n"